import styled from 'styled-components';
import { FontSize, inputStyle } from 'commons';

export const Input = styled.input`
  width: 100%;
  height: 100%;
  outline: none;
  padding: 4px 0;
  border-radius: inherit;
  background-color: transparent;
  color: ${({ theme }) => theme.neutral_900};
  font-size: ${FontSize.font12};
  font-weight: ${inputStyle.fontWeight};

  ::placeholder {
    opacity: ${inputStyle.placeholderOpacity};
  }

  &:read-only {
    cursor: unset;
  }
`;
